import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPageName: null,
  currentSubPageName: null,
};

const routeNameSlice = createSlice({
  initialState,
  name: "routeName",
  reducers: {
    setCurrentPageName: (state, { payload }) => {
      state.currentPageName = payload;
    },
    setCurrentSubPageName: (state, { payload }) => {
      state.currentSubPageName = payload;
    },
  },
});

export const { setCurrentPageName, setCurrentSubPageName } = routeNameSlice.actions;
export default routeNameSlice.reducer;
